import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { ImageModule } from 'primeng/image';
import { FirebaseFirestoreService } from '../../../services/firebase.firestore.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-personal-information',
  standalone: true,
  imports: [CommonModule, ButtonModule, ImageModule, DialogModule],
  templateUrl: './personal-information.component.html',
  styleUrls: ['./personal-information.component.scss']
})
export class PersonalInformationComponent {
  firebaseFirestoreService = inject(FirebaseFirestoreService);
  userProfile = this.firebaseFirestoreService.getUserProfile();
  dialogRef = inject(DynamicDialogRef);

  closeDialog() {
    this.dialogRef.close(true);
  }

  getExperienceLabel(experience: string): string {
    switch (experience) {
      case 'Occasional':
        return 'Occasional shopper';
      case 'Regular':
        return 'Regular shopper';
      case 'Expert':
        return 'Expert shopper';
      default:
        return experience || 'Not specified';
    }
  }

  getVehicleTypeLabel(type: string): string {
    switch (type) {
      case 'car':
        return 'Car';
      case 'suv':
        return 'SUV/Van';
      case 'truck':
        return 'Truck';
      default:
        return type || 'Not specified';
    }
  }

  getYesNoLabel(value: string): string {
    return value === 'yes' ? 'Yes' : value === 'no' ? 'No' : 'Not specified';
  }

  formatDate(dateString: string): string {
    if (!dateString) return 'Not specified';
    try {
      return new Date(dateString).toLocaleDateString();
    } catch {
      return dateString;
    }
  }
} 